export default __webpack_public_path__ + "static/media/student1.76bdc33f.gif";